import { Dialog, Toast } from "vant";
import { clearInvoiceSession } from "./session";
import { jumpToExternal, onClosePage } from "@/bridge/AppJsBridge";

export const isSessionError = error => Number(error && error.code) === 50001;

const getHttpUrl = (value, base) => {
  try {
    const url = new URL(value, base);
    return ["http:", "https:"].indexOf(url.protocol) >= 0 ? url : null;
  } catch (error) {
    return null;
  }
};

const getParentOrigin = () => {
  const ancestorOrigins = window.location.ancestorOrigins;
  if (ancestorOrigins && ancestorOrigins.length) {
    const ancestorUrl = getHttpUrl(ancestorOrigins[0]);
    if (ancestorUrl) return ancestorUrl.origin;
  }
  if (!document.referrer) return "";
  const referrerUrl = getHttpUrl(document.referrer);
  return referrerUrl ? referrerUrl.origin : "";
};

export const openInvoiceExternalLink = value => {
  const targetUrl = getHttpUrl(value, window.location.href);
  if (!targetUrl) return false;

  if (window.parent !== window) {
    const parentOrigin = getParentOrigin();
    if (parentOrigin) {
      window.parent.postMessage({
        type: "mobileGame:event",
        data: {
          eventName: "openExternalLink",
          eventData: { url: targetUrl.href },
        },
      }, parentOrigin);
      return true;
    }
    window.location.assign(targetUrl.href);
    return true;
  }

  const bridge = window.WebViewJavascriptBridge;
  if (bridge && typeof bridge.callHandler === "function") {
    jumpToExternal(JSON.stringify({ routePath: targetUrl.href }));
    return true;
  }

  window.location.assign(targetUrl.href);
  return true;
};

export const closeInvoiceCenter = () => {
  if (window.parent !== window) {
    const parentOrigin = getParentOrigin();
    if (parentOrigin) {
      window.parent.postMessage({ type: "mobileGame:closePage" }, parentOrigin);
      return;
    }
  }
  onClosePage();
};

export const handleInvoiceError = async error => {
  if (isSessionError(error)) {
    clearInvoiceSession();
    await Dialog.alert({ title: "提示", message: "页面已失效，请返回游戏重新打开开票中心" });
    closeInvoiceCenter();
    return;
  }
  Toast.fail((error && error.message) || "请求失败，请稍后重试");
};

export const formatMoney = amount => Number(amount || 0).toFixed(2);

export const formatTime = value => value ? String(value).replace("T", " ").slice(0, 19) : "";
